
namespace RioERP.Masters {
    export class TaxTypesColumns {
        static columnsKey = 'Masters.TaxTypes';
    }
}